import { apiClient } from './client';

// Mirrors packages/api/src/db/schema/content-refresh.ts.

export type ContentRefreshKind = 'refresh' | 'missing';
export type ContentRefreshStatus = 'open' | 'sent' | 'dismissed';

export interface ContentRefreshItem {
  id: string;
  weekOf: string;
  kind: ContentRefreshKind;
  title: string;
  ourUrl: string | null;
  score: number;
  sources: Array<'gsc' | 'semrush' | 'peec'>;
  suggestion: string;
  evidence: {
    gsc?: {
      clicks: number;
      prevClicks: number;
      impressions: number;
      position: number;
      queries: Array<{ query: string; impressions: number; clicks: number; position: number }>;
    };
    competitors?: Array<{
      domain: string;
      url: string;
      market: string;
      keywords: Array<{ keyword: string; volume: number; position: number }>;
    }>;
    peec?: Array<{ scope: string; domain: string | null; referenceUrls: string[] }>;
  };
  status: ContentRefreshStatus;
  notionPageUrl: string | null;
  decidedBy: string | null;
}

export interface ContentRefreshList {
  weekOf: string | null;
  items: ContentRefreshItem[];
}

export async function getRefreshList(week?: string) {
  return apiClient.get<ContentRefreshList>('/content-refresh', { params: week ? { week } : {} });
}

export async function sendRefreshItem(id: string) {
  return apiClient.post<{ item: ContentRefreshItem }>(`/content-refresh/${id}/send`);
}

export async function dismissRefreshItem(id: string) {
  return apiClient.post<{ item: ContentRefreshItem }>(`/content-refresh/${id}/dismiss`);
}
